import Search from './Search'
import Movies from './Movies'

function Home() {
  return (
    <div>
      <Search/>
      <Movies/>
    </div>
  )
}

export default Home
